<nz-form-item>
    <div nz-row>
      <div nz-col class="OTPColumn" nzSpan="24" style="text-align: center;">
        <button class="sendOTP" type=button *ngIf="!timerService.otpSended" nz-button nzType="primary" (click)="sendOtp(numberSendOtp)"
          [disabled]="disabled">
          INVIA OTP
        </button>
        <nz-progress
          *ngIf="timerService.otpSended" [nzPercent]="percentagePieChart" [nzFormat]="formatterPieChart" nzType="circle"
          [nzWidth]="65" >
        </nz-progress>
      </div>
    </div>
</nz-form-item>
<nz-form-item>
  <div nz-row>
    <div nz-col class="OTPColumn OTPForm" nzSpan="24">
      <nz-form-control nzHasFeedback [nzValidateStatus]="validateForm.controls.otpCode" [formGroup]="validateForm" [nzErrorTip]="errorTip">
        <nz-input-group nzPrefixIcon="lock" class="login" [nzSuffix]="otpCodeTemplate">
          <input [type]="otpCodeVisible ? 'text' : 'password'" nz-input name="otpCode" placeholder="Codice OTP"
            formControlName="otpCode" autocomplete="off"/>
        </nz-input-group>
        <ng-template #otpCodeTemplate>
          <i nz-icon [nzType]="otpCodeVisible ? 'eye-invisible' : 'eye'"
            (click)="otpCodeVisible = !otpCodeVisible"></i>
        </ng-template>
      </nz-form-control>
    </div>
  </div>
</nz-form-item>
